import DashboardV from './Dashboard.v';
import { withRouter } from 'core/withRouter';
import React, { useEffect, useState } from 'react';
import PageUtil from 'utils/Page.util';
import { DashboardDataDTO } from 'models/dashboard';
import receptionService from 'services/reception.service';
import moment from 'moment';
import { useNavigate } from 'react-router';
import pageStateService from 'core/PageState.service';

class Params {
    error: string = null;
    isLoaded: boolean = false;
    year: string = moment().format("YYYY");
    // 서버에서 받아온 전체 데이터
    dashboardData: DashboardDataDTO = new DashboardDataDTO();
}

function Dashboard(props: any) {
    const [params, setParams] = useState(new Params());
    const navigate = useNavigate();

    /* ***************************************************************************************** */
    /* ************************************* STATE ********************************************* */
    /* ***************************************************************************************** */

    // 컴포넌트 마운트 시 데이터 로드
    useEffect(() => {
        getData();
    }, []);

    /* ***************************************************************************************** */
    /* ************************************* BASIC ********************************************* */
    /* ***************************************************************************************** */

    async function goPage(path: string) {
        await pageStateService.clearPageState();
        navigate(path);
    }

    /**
     * 대시보드 데이터 로드
     * - 단일 API 호출로 모든 데이터 조회
     */
    async function getData() {
        try {
            setParams(prev => ({ ...prev, isLoaded: false }));

            // 단일 API 호출로 모든 데이터 조회
            const dashboardData = await receptionService.getDashboardData(params.year);

            console.log("dashboardData", dashboardData);

            setParams(prev => ({
                ...prev,
                isLoaded: true,
                error: null,
                dashboardData: dashboardData
            }));

        } catch (error) {
            setParams(prev => ({
                ...prev,
                isLoaded: true,
                error: error as any
            }));
            PageUtil.handleApiError(error);
        }
    }

    const args = {
        params: params,
        goPage: goPage,
    };

    return <DashboardV {...args}></DashboardV>;
}

export default withRouter(Dashboard);